<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("PURCHASES_PAYMENTS.EDIT_PURCHASES_PAYMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <purchasesPayment-form
              :loading="loading"
              :purchasesPaymentData="purchasesPayment"
              :formErrors="formErrors"
              @purchasesPaymentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import PurchasesPaymentForm from "./partials/PurchasesPaymentForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesPayment from "./defaultPurchasesPayment";

export default {
  layout: "DashboardLayout",

  components: { PurchasesPaymentForm },

  mixins: [alertLeave],

  data() {
    return {
      purchasesPayment: cloneDeep(defaultPurchasesPayment),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("purchasesPayments/get", id);
        this.purchasesPayment =
          this.$store.getters["purchasesPayments/purchasesPayment"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List PurchasesPayments" });
    },

    viewPurchasesPayment() {
      this.alertLeave = false;
      this.$router.push({
        name: "View PurchasesPayment",
        params: { id: this.purchasesPayment.id },
      });
    },

    async handleSubmit(purchasesPayment) {
      this.loading = true;

      const purchasesPaymentData = cloneDeep(purchasesPayment);
      if (!purchasesPaymentData.organization.id) {
        delete purchasesPaymentData.organization;
      }
      if (!purchasesPaymentData.reseller.id) {
        delete purchasesPaymentData.reseller;
      }

      try {
        await this.$store.dispatch(
          "purchasesPayments/update",
          purchasesPaymentData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_PAYMENTS.PURCHASES_PAYMENTS_UPDATED"),
        });
        this.viewPurchasesPayment();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
